import axios from "axios";
import { getAuthorizationToken } from "../config/user";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function managerpa(caseId, data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-hospital-details/:hospitalid${caseId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function manageApplicationId() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-application-list?limit=20`,
    headers: getAuthorizationToken(),
  });
}

function checkNewCaseAdded(hospitalId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-requests?hospitalId=${hospitalId}&requestStatus=NEW&caseStatus=NEW_CASE`,
    headers: getAuthorizationToken(),
  });
}

function manageRpaLogs(
  applicationid,
  searchKey,
  page,
  limit,
  startDate,
  endDate,
  hospitalId,
  requestStatus,
  caseStatus,
  subRequestType,
  isTpa = "",
) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Normalize by resetting time parts
  start.setHours(0, 0, 0, 0);

  if (start.getTime() === new Date(end).setHours(0, 0, 0, 0)) {
    // If start and end are same, set end to end of day
    end.setHours(23, 59, 59, 999);
  } else {
    // Else normalize end date to end of day for proper range
    end.setHours(23, 59, 59, 999);
  }

  const isTpaParam =
    isTpa === 0 || isTpa === 1 || isTpa === "0" || isTpa === "1"
      ? `&isTpa=${isTpa}`
      : "";

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-requests?startDate=${start.toISOString()}&endDate=${end.toISOString()}&hospitalId=${hospitalId}&applicationId=${applicationid}&page=${page}&requestStatus=${requestStatus}&caseStatus=${caseStatus}&requestType=${subRequestType}&limit=${limit}&searchKey=${searchKey}${isTpaParam}`,
    headers: getAuthorizationToken(),
  });
}

function manageRpaHospitalLogs(page, limit, hospitalId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-requests?hospitalId=${hospitalId}&page=${page}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
}

function manageRpaProcessedLogs(
  applicationid,
  searchKey,
  page,
  limit,
  startDate,
  endDate,
  hospitalId,
  requestStatus,
  caseStatus,
  isTpa = "",
) {
  const isTpaParam =
    isTpa === 0 || isTpa === 1 || isTpa === "0" || isTpa === "1"
      ? `&isTpa=${isTpa}`
      : "";

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-processed-requests?startDate=${new Date(
      startDate,
    ).toISOString()}&endDate=${new Date(
      endDate,
    ).toISOString()}&hospitalId=${hospitalId}&applicationId=${applicationid}&page=${page}&requestStatus=${requestStatus}&caseStatus=${caseStatus}&limit=${limit}&searchKey=${searchKey}${isTpaParam}`,
    headers: getAuthorizationToken(),
  });
}

function updateRpaRequest(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/update-rpa-request-status`,
    headers: getAuthorizationToken(),
    data: data,
  });
}

function getHospitalsFromId(applicationid, page, searchKey, limit) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-app-hospital-list?applicationId=${applicationid}&page=${page}&searchKey=${searchKey}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
}
function getHoldHospital() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-hold-hospital-count`,
    headers: getAuthorizationToken(),
  });
}
function getHoldApplication() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-hold-application-count`,
    headers: getAuthorizationToken(),
  });
}
function updateRpaDeviceDetails(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-rpa-devices-details`,
    headers: getAuthorizationToken(),
    data: data,
  });
}
function updateRpaHospital(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-rpa-hospital-mapping`,
    headers: getAuthorizationToken(),
    data: data,
  });
}

function getTmsQueries(id) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-queries/${id}`,
    headers: getAuthorizationToken(),
  });
}
function manageQueries(
  status,
  page,
  limit,
  searchKey,
  hospitalId,
  commandCenterStage,
  pmjayId,
  forwardedTo = "",
  forwarded = false,
  assignedTo = "",
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/all-queries?status=${status}&page=${page}&limit=${limit}&hospitalId=${hospitalId}&searchKey=${searchKey}&commandCenterStage=${commandCenterStage}&pmjayId=${pmjayId}&forwardedTo=${forwardedTo}&forwarded=${forwarded}&assignedTo=${assignedTo}`,
    headers: getAuthorizationToken(),
  });
}

function getCaseQueryCounts(
  hospitalId,
  forwardedTo = "",
  forwarded = true,
  assignedTo = "",
) {
  let url = `${REACT_APP_API_URL}/case-query-count?hospitalId=${hospitalId}&forwardedTo=${forwardedTo}&forwarded=${forwarded}&assignedTo=${assignedTo}`;
  // if (hospitalId) {
  //   url += `?hospitalId=${hospitalId}`;
  // }
  return axios({
    method: "get",
    url: url,
    headers: getAuthorizationToken(),
  });
}

function rpaRequests(requestStatus, limit, caseStatus) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-requests?page=1&requestStatus=${requestStatus}&limit=${limit}&caseStatus=${caseStatus}`,
    headers: getAuthorizationToken(),
  });
}
function rpaStatus(page, hospitalId, requestStatus) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-requests?page=1&hospitalId=702ae8de-25e6-4f7b-bb11-6087f515a7f4&requestStatus=${requestStatus}&hospitalId=${hospitalId}&page=${page}`,
    headers: getAuthorizationToken(),
  });
}

function updateTmsQueriesStatus(queryIds, status) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/case-query-status-update?queryIds=${encodeURIComponent(
      JSON.stringify(queryIds),
    )}&status=${status}`,
    headers: getAuthorizationToken(),
  });
}
function markQueryReadyForTms({ queryId, isNewDocMapped, body }) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/mark-query-ready-for-tms`,
    params: {
      queryId,
      isNewDocMapped,
    },
    data: body,
    headers: getAuthorizationToken(),
  });
}
function addRpaRequest(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-rpa-request`,
    headers: getAuthorizationToken(),
    data: data,
  });
}
function handleSubmitApplication(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/register-rpa-devices`,
    headers: getAuthorizationToken(),
    data: data,
  });
}
function handleDeleteApplication(data) {
  return axios({
    method: "delete",
    url: `${REACT_APP_API_URL}/delete-rpa-devices`,
    headers: getAuthorizationToken(),
    data: data,
  });
}
function rpaRunningHospitals() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-running-hospitals`,
    headers: getAuthorizationToken(),
  });
}
function getTmsLoginCredentials(page, limit, searchKey) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-tms-user?page=${page}&limit=${limit}&searchKey=${searchKey}`,
    headers: getAuthorizationToken(),
  });
}
function getRpaErrorReport(fromDate, toDate) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-error-report?from=${new Date(
      fromDate,
    ).toISOString()}&to=${new Date(toDate).toISOString()}`,
    headers: getAuthorizationToken(),
  });
}
function getRpaErrorLogs(
  page = 1,
  limit = 10,
  searchKey = "",
  fromDate,
  toDate,
  hospitalId,
  requestStatus,
  caseStatus,
  processedBy,
  targetRequests,
  ownerName,
  filterDateType,
  applicationId,
  errorCode,
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-error-log?page=${page}&limit=${limit}&searchKey=${searchKey}&startDate=${fromDate}&endDate=${toDate}&hospitalId=${hospitalId}&requestStatus=${requestStatus}&caseStatus=${caseStatus}&processedBy=${processedBy}&targetRequests=${targetRequests}&ownerName=${ownerName}&filterBy=${filterDateType}&applicationId=${applicationId}&errorCode=${errorCode}`,
    headers: getAuthorizationToken(),
  });
}
function getRpaErrorLogsWithoutRequests(
  page,
  limit,
  searchKey,
  fromDate,
  toDate,
  applicationId,
  errorCode,
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-error-log-without-req?page=${page}&limit=${limit}&searchKey=${searchKey}&startDate=${fromDate}&endDate=${toDate}&applicationId=${applicationId}&errorCode=${errorCode}`,
    headers: getAuthorizationToken(),
  });
}
function getDutCaseDetails(pmjayRegistrationId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-details-rpa?isRpa=true&pmjayRegistrationId=${pmjayRegistrationId}`,
    headers: getAuthorizationToken(),
  });
}
function getRpaRequestProcessReport(
  page = 1,
  limit = 10,
  searchKey = "",
  fromDate,
  toDate,
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-request-process-report?page=${page}&limit=${limit}&searchKey=${searchKey}&from=${fromDate}&to=${toDate}`,
    headers: getAuthorizationToken(),
  });
}
// function getRpaProcessTimeReport(
//   page = 1,
//   limit = 10,
//   searchKey = "",
//   startDate,
//   endDate
// ) {
//   return axios({
//     method: "get",
//     url: `${REACT_APP_API_URL}/rpa-process-time-report?page=${page}&limit=${limit}&searchKey=${searchKey}&startDate=${startDate}&endDate=${endDate}`,
//     headers: getAuthorizationToken(),
//   });
// }

function addPmjayQuery(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/addpmjayquery`,
    headers: getAuthorizationToken(),
    data: data,
  });
}
function assignTempDevice(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/assign-temp-rpa-application`,
    headers: getAuthorizationToken(),
    params: {
      // <-- query params go here
      assignWithoutAddReq: data.assignWithoutAddReq,
    },
    data: {
      hospitalId: data.hospitalId,
      applicationId: data.applicationId,
    },
  });
}

function updateMultipleRequestsStatus(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-multiple-rpa-request-status`,
    headers: getAuthorizationToken(),
    data: data,
  });
}

function forwardCaseQuery({
  queryId,
  forwardedToIds = [],
  forwardedToTeam = "",
  comment = "",
} = {}) {
  const ids = Array.isArray(forwardedToIds)
    ? forwardedToIds.filter(Boolean).map(String)
    : [];
  const safeComment = String(comment ?? "");

  const qid = String(queryId ?? "");
  const forwardedTo = encodeURIComponent(JSON.stringify(ids)); // only this one is encoded
  const forwardComment = JSON.stringify({ comment: safeComment });
  const team = String(forwardedToTeam ?? "");

  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/forward-case-query?queryId=${qid}&forwardedToTeam=${team}&forwardedTo=${forwardedTo}&forwardComment=${forwardComment}`,
    headers: getAuthorizationToken(),
  });
}

function forwardCaseQueryToHsa({
  queryId,
  forwardedToIds,
  forwardedToTeam = "hsa",
  comment = "",
  reforward = true,
  isNewDocMapped,
  documents = [],
} = {}) {
  const ids =
    Array.isArray(forwardedToIds) && forwardedToIds.length > 0
      ? forwardedToIds.filter(Boolean).map(String)
      : ["hsa"];

  const qid = String(queryId ?? "");

  const forwardTo = encodeURIComponent(JSON.stringify(ids));

  const forwardCommentObj = {
    comment: String(comment || ""),
    attachment: "",
  };

  const forwardComment = encodeURIComponent(JSON.stringify(forwardCommentObj));

  const finalUrl = `${REACT_APP_API_URL}/forward-case-query?queryId=${qid}&forwardedToTeam=${forwardedToTeam}&forwardedTo=${forwardTo}&forwardComment=${forwardComment}&reforward=${reforward}&isNewDocMapped=${isNewDocMapped}`;

  return axios({
    method: "put",
    url: finalUrl,
    headers: getAuthorizationToken(),
    data: {
      documents: Array.isArray(documents) ? documents : [],
    },
  });
}

export const markWorkInProgress = (queryId) => {
  return axios.put(`${REACT_APP_API_URL}/wip-case-query`, null, {
    params: { queryId },
    headers: getAuthorizationToken(),
  });
};

export const wipAssignCaseQuery = (id, wipTo, reWip = true) => {
  // console.log("hello", queryId, wipTo, reWip);

  return axios.put(
    `${REACT_APP_API_URL}/wip-assign-case-query?queryId=${id}&wipTo=${wipTo}&reWip=${reWip}`,
    {},
    {
      headers: getAuthorizationToken(),
    },
  );
};

export const removeWorkInProgress = (queryId) => {
  return axios.put(
    `${REACT_APP_API_URL}/remove-wip-from-case-query?queryId=${queryId}`,
    {},
    {
      headers: getAuthorizationToken(),
    },
  );
};

function moveOutOfRpaQueue(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/move-case-outof-rpaqueue`,
    headers: getAuthorizationToken(),
    data: data,
  });
}

export const RpaServices = {
  managerpa,
  manageApplicationId,
  getHospitalsFromId,
  updateRpaDeviceDetails,
  getTmsQueries,
  updateTmsQueriesStatus,
  manageQueries,
  rpaRequests,
  rpaStatus,
  updateRpaHospital,
  getHoldHospital,
  getHoldApplication,
  addRpaRequest,
  handleSubmitApplication,
  handleDeleteApplication,
  manageRpaLogs,
  updateRpaRequest,
  manageRpaProcessedLogs,
  manageRpaHospitalLogs,
  rpaRunningHospitals,
  checkNewCaseAdded,
  getRpaErrorReport,
  getRpaErrorLogs,
  getRpaErrorLogsWithoutRequests,
  getRpaRequestProcessReport,
  addPmjayQuery,
  getTmsLoginCredentials,
  // getRpaProcessTimeReport,
  assignTempDevice,
  getCaseQueryCounts,
  updateMultipleRequestsStatus,
  forwardCaseQuery,
  forwardCaseQueryToHsa,
  markQueryReadyForTms,
  markWorkInProgress,
  wipAssignCaseQuery,
  removeWorkInProgress,
  getDutCaseDetails,
  moveOutOfRpaQueue,
};
